module.exports = __webpack_public_path__ + "img/facebook.1c7101e5.svg";